/* hgn-side-cart-kit-checkout.js — moved verbatim from snippets/hgn-side-cart-kit-checkout.liquid on 2026-09-16 (page-weight phase B:
   inline JS → theme asset, loaded synchronously at the same position so execution order and
   DOMContentLoaded timing are unchanged). 1 original <script> block(s), in order.
   EDIT THIS FILE, not the snippet. */

(function () {
  'use strict';
  var B = window.__hgnSideCartBridge;
  if (!B || !B.HGNSideCart) return;
  var HGNSideCart       = B.HGNSideCart;
  var escapeHtml        = B.helpers.escapeHtml;
  var formatMoney       = B.helpers.formatMoney;
  var gbpToActiveCents  = B.helpers.gbpToActiveCents;
  var activeKey         = B.helpers.activeKey;
  var isGiftLineItem    = B.helpers.isGiftLineItem;

  /* Find the most-complete kit tier that's at minimum but hasn't
     been finalised yet (no bundle for that tier in cart). Returns
     `{ tier, minimum, savingsGbp, label }` or null. Ties broken by
     tier order — classic > gels > press-ons. We don't surface tiers
     below minimum (the prompt would feel pushy when the kit isn't
     actually one tap from saving). */
  HGNSideCart.prototype._findUnfinalisedReadyKit = function () {
    if (!window.HGN || !window.HGN.kitProgress) return null;
    var kp = window.HGN.kitProgress;
    if (typeof kp.getKitBuildMode !== 'function' || kp.getKitBuildMode() !== 'on') return null;
    var minimums = (window.HGN && window.HGN.STARTER_KIT_MINIMUMS) ||
      { classic: 5, gels: 3, 'press-ons': 3 };
    var labels = {
      classic:     'Classic Starter Kit',
      gels:        'Gel Starter Kit',
      'press-ons': 'Press-On Starter Kit'
    };
    /* Skip a tier that's already represented as a bundle in the
       cart — shopper has already finalised it; no need to nudge. */
    var bundleTiersInCart = {};
    var items = (this.cart && this.cart.items) || [];
    items.forEach(function (it) {
      var p = it.properties || {};
      var bt = String(p._bundle_type || '');
      if (/^classic-starter-kit/.test(bt)) bundleTiersInCart.classic = true;
      else if (/^gels-starter-kit/.test(bt)) bundleTiersInCart.gels = true;
      else if (/^press-ons-starter-kit/.test(bt)) bundleTiersInCart['press-ons'] = true;
    });
    var tiers = ['classic', 'gels', 'press-ons'];
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      if (bundleTiersInCart[t]) continue;
      /* Skip tiers disabled in this market — even if cross-market
         localStorage has lingering picks at minimum, we shouldn't
         offer to finalise a kit the shopper can't actually buy here. */
      if (typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(t)) continue;
      var kit = kp.getKit ? kp.getKit(t) : null;
      if (!kit || !kit.items) continue;
      var picksLen = kit.items.length;
      var minimum = minimums[t] || 0;
      if (minimum <= 0 || picksLen < minimum) continue;
      /* Use the same math the side cart's pricing block uses so the
         saving figure the modal quotes matches what's in the kit
         section above. */
      var math = (window.HGN && typeof window.HGN.computeKitMath === 'function')
        ? window.HGN.computeKitMath(t, kit)
        : null;
      var savingsGbp = (math && math.savings) ? math.savings : 0;
      /* LOCAL-sticker markets (M4): computeKitMath attaches a
         `.local` overlay — pass it through so the prompt quotes the
         same fixed-local-currency saving as the kit pricing block.
         Null on GBP + unconfigured markets → GBP path unchanged. */
      var savingsLocal = (math && math.local) ? math.local : null;
      return {
        tier:         t,
        minimum:      minimum,
        savingsGbp:   savingsGbp,
        savingsLocal: savingsLocal,
        label:        labels[t] || 'Starter Kit'
      };
    }
    return null;
  };

  /* ─────── Foot-button-as-kit-CTA (Matt, 2026-08-08) ───────
     Review-then-add left ready kits stranded: the beacon funnel showed
     all-set → in-basket falling from ~95% to ~65% in the three days
     after auto-finalise was retired, with the commit button lost
     mid-list and a dead CHECKOUT over a £0.00 subtotal below it.
     When the cart has NO lines and a ready kit exists, the foot
     button becomes the kit CTA instead:
       - all required slots picked → "Checkout with my kit": one tap
         finalises (via hgn:kit:finalise-request), waits for the kit
         bundle to land in the refreshed cart, then runs the normal
         checkout flow (BASKET-* mint included).
       - required slots missing → "Finish my kit": jumps to the build
         section's accessory step.
     Real "Checkout" copy only returns once actual cart lines exist. */
  HGNSideCart.prototype._emptyKitFootState = function () {
    if (this.cart && this.cart.item_count) return null;
    var info = this._findUnfinalisedReadyKit();
    if (!info) return null;
    var allSet = false;
    try {
      if (window.HGN && typeof window.HGN.kitFinaliseState === 'function') {
        var st = window.HGN.kitFinaliseState(info.tier);
        allSet = !!st && st.unfilled === 0;
      }
    } catch (e) {}
    return { tier: info.tier, allSet: allSet };
  };

  HGNSideCart.prototype._syncCheckoutLabel = function () {
    if (!this.checkoutLabelEl) return;
    /* `_checkoutMintFailed` holds the CTA on "Continue without
       discount" until the shopper taps it (audit A1) — a stray
       hgn:kit:change re-render must not quietly relabel the button
       back to "Checkout" underneath the note explaining why. */
    if (this._kitCheckoutPending || this._checkoutInflight || this._checkoutMintFailed) return;
    var st = this._emptyKitFootState();
    /* Curation-aware (KIT-BUILD §11h, 2026-09-15): name the edit the kit was
       started from — "Checkout with my Halloween Edit" — else the generic label. */
    var kpEdit = (window.HGN && window.HGN.kitProgress) || null;
    var editTier = (st && st.tier) || (kpEdit && typeof kpEdit.getFocus === 'function' ? kpEdit.getFocus() : null);
    var editName = (st && st.allSet && kpEdit && editTier && typeof kpEdit.kitEditLabel === 'function') ? kpEdit.kitEditLabel(editTier) : null;
    if (st && st.allSet)  this.checkoutLabelEl.textContent = editName ? ('Checkout with my ' + editName) : 'Checkout with my kit';
    else if (st)          this.checkoutLabelEl.textContent = 'Finish my kit';
    else                  this.checkoutLabelEl.textContent = 'Checkout';
  };

  /* ─────── Checkout mint gate (audit A1, 2026-08-12) ───────
     Live-reproduced: 1 of 3 hand-offs put the shopper on Shopify's
     payment page at CHF 132.00 against a promised CHF 68.99. The
     default path used to call goPlain() on ANY unhappy mint — a
     non-OK response, a response with no code, or a rejected fetch
     (a cross-origin refusal from a market subdomain rejects in
     ~300ms, long before the worker's ~1.1s mint even answers) — with
     nothing but a console.warn between the shopper and full price.
     Losing the discount silently is the one outcome the drawer must
     never produce, so the "never block checkout" rule bends here
     exactly as far as it does for Nail Points: we still let them
     through, but only after they've been told.

     This is the single mint entry point for the default (kit/gift)
     intent. It RESOLVES — never rejects — with either:
       { code: 'BASKET-…' }              mint CONFIRMED (r.ok + code)
       { code: null, reason: '<why>' }   unconfirmed; caller must surface
     Each attempt is capped at MINT_TIMEOUT_MS so a hung request can't
     leave the shopper staring at a dead button, and a retryable
     failure (network / timeout / 5xx) gets exactly one more go — a
     clean "no code" answer is a verdict, not a blip, so it isn't
     retried. Callers navigate ONLY on a confirmed code. */
  var MINT_TIMEOUT_MS = 6000;
  var MINT_ENDPOINT   = 'https://holygrailnail.co/api/cart-discount/create';

  /* kit5 attach-before-mint (2026-08-13, RESTORED — dropped in a
     cross-session file overwrite). Resolves the dual-offer attach
     BEFORE any mint math: reuses an in-flight attach, re-arms a fresh
     /held check otherwise, capped so a slow popup worker can never
     stall the gate — on cap we proceed without the fold (pre-fix
     behaviour, now rare instead of first-click-certain). Caller:
     the kit5Ensured hook at the top of _proceedToCheckout. */
  var KIT5_ATTACH_CAP_MS = 2500;
  HGNSideCart.prototype._ensureKit5Attached = function () {
    var work;
    try {
      if (this._getKit5Token && this._getKit5Token()) {
        work = Promise.resolve();
      } else if (this._kit5AttachPromise) {
        work = this._kit5AttachPromise;
      } else if (typeof this._maybeAutoAttachKit5 === 'function') {
        this._kit5HeldTried = false;
        work = this._maybeAutoAttachKit5() || Promise.resolve();
      } else {
        work = Promise.resolve();
      }
    } catch (e) { work = Promise.resolve(); }
    return new Promise(function (resolve) {
      var t = setTimeout(resolve, KIT5_ATTACH_CAP_MS);
      Promise.resolve(work).then(
        function () { clearTimeout(t); resolve(); },
        function () { clearTimeout(t); resolve(); }
      );
    });
  };

  HGNSideCart.prototype._mintBasketCode = function (savingsGbpCents, presentment) {
    var self = this;
    this._mintInflight = true;
    /* A3: the caller (main IIFE, where activeKey / gbpCentsToActiveCents
       are in closure scope) hands us the same saving expressed in the
       shopper's own currency. Shopify converts a fixed GBP discount at
       ITS market rate, not ours, so a fixed local sticker can't be hit
       via GBP (CHF 68.99 settled at CHF 67.79, 2026-08-12). LIVE since
       the worker's percentage mint (2026-08-13): on non-GBP markets the
       worker divides these two figures and mints a PERCENTAGE, which
       carries no currency and so survives no FX step at all. Omitted
       entirely when the caller passes nothing — the worker falls back to
       the fixed-GBP path, which is also what every GBP request gets. */
    var payload = { totalSavingsCents: savingsGbpCents };
    if (presentment && typeof presentment === 'object') {
      if (presentment.presentmentCents != null) payload.presentmentCents = presentment.presentmentCents;
      if (presentment.presentmentCurrency)      payload.presentmentCurrency = presentment.presentmentCurrency;
      /* The denominator. `items_subtotal_price` is presentment cents
         after line-level discounts — the same base Shopify computes an
         "Amount off order" percentage from, so savings ÷ subtotal is the
         percentage that lands the drawer's exact sticker at checkout.
         Read HERE rather than passed in: `this.cart` is already on the
         instance, so the main IIFE's presentment builder stays untouched.
         Sent only alongside the pair — on its own it means nothing. */
      var eligibleCents = (self.cart && self.cart.items_subtotal_price) || 0;
      if (payload.presentmentCents != null && eligibleCents > 0) {
        payload.presentmentSubtotalCents = eligibleCents;
      }
    }
    /* Referral gift (REFERRAL-BUILD.md §6 · SIDE-CART.md §18). The
       referral snippet — when pasted — returns `{ referralId,
       referralGiftCents }` (GBP pence, the same unit as
       totalSavingsCents) for a live claim. Additive and optional on
       BOTH sides: absent here when no claim, ignored by a worker that
       hasn't had its referral hunk pasted, and a claim the loyalty
       worker refuses to verify comes back as a normal mint WITHOUT the
       gift. Nothing in this path can block checkout. */
    if (typeof self._referralMintFields === 'function') {
      try {
        var rf = self._referralMintFields();
        if (rf && rf.referralId) {
          payload.referralId = rf.referralId;
          if (rf.referralGiftCents > 0) payload.referralGiftCents = rf.referralGiftCents;
        }
      } catch (e) {}
    }

    function attempt() {
      var ctrl = null;
      var timer = null;
      try { ctrl = new AbortController(); } catch (e) { ctrl = null; }
      var init = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify(payload)
      };
      if (ctrl) init.signal = ctrl.signal;
      /* Race the request against the cap rather than relying on the
         abort alone — AbortController is missing in a couple of the
         older in-app WebViews, and there the timeout still has to
         hand a verdict back. */
      var timed = new Promise(function (resolve) {
        timer = setTimeout(function () {
          try { if (ctrl) ctrl.abort(); } catch (e) {}
          resolve({ code: null, reason: 'timeout', retryable: true });
        }, MINT_TIMEOUT_MS);
      });
      var live = fetch(MINT_ENDPOINT, init)
        .then(function (r) {
          if (!r.ok) return { code: null, reason: 'http-' + r.status, retryable: r.status >= 500 };
          return r.json()
            .then(function (data) {
              /* Referral gift verdict rides on the mint response
                 (REFERRAL-BUILD.md §14). Never a blocker: the mint
                 itself always succeeds, and `skipped:<reason>` just
                 means the shopper checks out without the free set. */
              if (data && data.referralGift != null && typeof self._noteReferralMintResult === 'function') {
                try { self._noteReferralMintResult(data.referralGift); } catch (e) {}
              }
              if (data && data.code) return { code: data.code };
              return { code: null, reason: (data && data.error) || 'no-code', retryable: false };
            })
            .catch(function () { return { code: null, reason: 'bad-json', retryable: true }; });
        })
        .catch(function (err) {
          /* A CORS refusal, an offline radio and a DNS miss all land
             here as an opaque TypeError — all retryable. */
          return { code: null, reason: 'network:' + ((err && err.message) || 'failed'), retryable: true };
        });
      return Promise.race([live, timed]).then(function (res) {
        if (timer) clearTimeout(timer);
        return res;
      });
    }

    return attempt()
      .then(function (res) {
        if (res.code || !res.retryable) return res;
        if (window && window.console) {
          console.warn('[hgn-side-cart] mint attempt 1 unconfirmed (' + res.reason + ') — retrying once');
        }
        return attempt();
      })
      .then(function (res) {
        self._mintInflight = false;
        if (window && window.console) {
          if (res.code) console.info('[hgn-side-cart] mint CONFIRMED', res.code, '→ /checkout?discount=' + res.code);
          else console.warn('[hgn-side-cart] mint UNCONFIRMED after retry:', res.reason, '— holding the shopper');
        }
        return res;
      });
  };

  /* The gate's failure surface. Deliberately does NOT navigate: the
     shopper's next tap on the CTA is their explicit "go anyway", and
     _handleCheckout's _checkoutMintFailed branch owns that. Copy
     names what happened and what it costs, because the behaviour
     this replaces was a full-price checkout page with no explanation
     at all. */
  HGNSideCart.prototype._armCheckoutWithoutDiscount = function (res) {
    this._checkoutMintFailed = true;
    /* Pin the basket this verdict belongs to — if the shopper edits
       the cart before tapping again, the next tap earns a fresh mint
       attempt rather than the acknowledged full-price shortcut. */
    this._mintFailedSig = this._cartSignature();
    if (this.checkoutBtn) this.checkoutBtn.disabled = false;
    if (this.checkoutLabelEl) this.checkoutLabelEl.textContent = 'Continue without discount';
    /* Both routes named, both true: tapping again really does mean
       full price, and re-opening the bag really does re-arm a fresh
       mint attempt (HGNSideCart.prototype.open clears this state). */
    this._setCheckoutNote(
      '<strong>We couldn\u2019t apply your savings just now.</strong> Tap again to check out at ' +
      'full price \u2014 or close your bag and open it again in a moment to retry the discount.'
    );
    try {
      document.dispatchEvent(new CustomEvent('hgn:checkout:mint-failed', {
        detail: { reason: (res && res.reason) || 'unknown' }
      }));
    } catch (e) {}
  };

  HGNSideCart.prototype._cartSignature = function () {
    var c = this.cart || {};
    return String(c.item_count || 0) + ':' + String(c.total_price || 0);
  };

  HGNSideCart.prototype._setCheckoutNote = function (html) {
    if (!this.checkoutNoteEl) return;
    this.checkoutNoteEl.innerHTML = html;
    this.checkoutNoteEl.hidden = false;
  };

  HGNSideCart.prototype._clearCheckoutNote = function () {
    if (!this.checkoutNoteEl) return;
    this.checkoutNoteEl.hidden = true;
    this.checkoutNoteEl.innerHTML = '';
  };

  /* ─────── Virtual kit basket (Matt, 2026-08-08 rev 3) ───────
     The first cut of one-tap checkout left the foot reading
     "SUBTOTAL £0.00" under a ready £59.99 kit, the meter demanding
     "£39.99 to free shipping" on a kit that ships free, and no sign
     the kit had earned the free gift — the drawer looked EMPTY at the
     exact moment it should have looked bought. When the cart has no
     lines but a ready kit exists, the kit IS the basket: the foot
     shows the kit price + savings, and the shipping/gift meter is fed
     the kit's value so free shipping + the free gift celebrate before
     the tap. All figures come from the same computeKitMath the kit
     pricing block uses, so the two surfaces can never disagree.
     The free-gift orchestrator deliberately does NOT see this virtual
     value — the real gift line is added only after the kit's lines
     land (the one-tap flow waits for it; see _finaliseKitThenCheckout). */
  HGNSideCart.prototype._virtualKitBasket = function () {
    if (this.cart && this.cart.item_count) return null;
    var info = this._findUnfinalisedReadyKit();
    if (!info) return null;
    var kp = window.HGN && window.HGN.kitProgress;
    var kit = kp && typeof kp.getKit === 'function' ? kp.getKit(info.tier) : null;
    var math = (kit && window.HGN && typeof window.HGN.computeKitMath === 'function')
      ? window.HGN.computeKitMath(info.tier, kit)
      : null;
    if (!math || !math.kitPrice) return null;
    var loc = math.local || null;
    var kitPriceCents, savingsCents, isoCode;
    if (loc) {
      /* LOCAL-sticker markets: the overlay's figures ARE presentment. */
      kitPriceCents = Math.round((loc.kitPrice || 0) * 100);
      savingsCents  = Math.round((loc.savings  || 0) * 100);
      isoCode = loc.currency;
    } else {
      kitPriceCents = gbpToActiveCents(math.kitPrice || 0);
      savingsCents  = gbpToActiveCents(math.savings  || 0);
      isoCode = activeKey().toUpperCase();
    }
    if (!kitPriceCents) return null;
    /* Gift preview — the kit's value alone can clear the gift
       threshold. Same threshold accessor the orchestrator uses; the
       gift retail joins the savings figure because that's exactly
       what the post-finalise foot will show (BASKET-* covers it). */
    var giftUnlocked = false;
    var giftRetailCents = 0;
    var giftTier = this.config.gift && this.config.gift.tiers && this.config.gift.tiers[0];
    if (giftTier && giftTier.variantId && !this._isNailPointsActive() &&
        kitPriceCents >= this._getGiftThresholdCents()) {
      giftUnlocked = true;
      giftRetailCents = gbpToActiveCents(typeof giftTier.price === 'number' ? giftTier.price : 0);
    }
    /* kit5 fold (2026-08-13): the drawer is the storefront — an attached
       token's £5 shows HERE (subtotal down, savings up), so the foot
       matches Shopify checkout to the penny. Same GBP-pence conversion
       the folded-cart foot uses. */
    var foldCents = 0;
    try {
      foldCents = this._kit5FoldGbpCents
        ? gbpToActiveCents(this._kit5FoldGbpCents() / 100)
        : 0;
    } catch (e) { foldCents = 0; }
    return {
      tier:            info.tier,
      kitPriceCents:   Math.max(0, kitPriceCents - foldCents),
      savingsCents:    savingsCents + giftRetailCents + foldCents,
      giftUnlocked:    giftUnlocked,
      isoCode:         isoCode
    };
  };

  /* One-tap kit checkout: finalise, wait for the bundle to appear in
     a refreshed cart, then proceed to the normal checkout flow. The
     settle condition is "this tier's bundle is IN the cart" (not just
     any cart change) so an unrelated refresh can't race us into
     checkout without the kit. Failure paths (OOS modal, /cart/add
     422 retry modal) never produce the bundle — the timeout restores
     the button and the kit-build modals own the recovery. */
  HGNSideCart.prototype._finaliseKitThenCheckout = function (tier) {
    var self = this;
    if (this._kitCheckoutPending) return;
    this._kitCheckoutPending = true;
    if (this.checkoutBtn) this.checkoutBtn.disabled = true;
    if (this.checkoutLabelEl) this.checkoutLabelEl.textContent = 'Adding your kit…';
    function cartHasKit(cart) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        var bt = String((items[i].properties || {})._bundle_type || '');
        if (bt.indexOf(tier + '-starter-kit') === 0) return true;
      }
      return false;
    }
    var settled = false;
    function settle(proceed) {
      if (settled) return;
      settled = true;
      self._kitCheckoutPending = false;
      document.removeEventListener('hgn:cart:change', onCartChange);
      if (self.checkoutBtn) self.checkoutBtn.disabled = false;
      if (proceed) self._proceedToCheckout();
      else self._syncCheckoutLabel();
    }
    function onCartChange(e) {
      var cart = e && e.detail && e.detail.cart;
      if (!cart || !cartHasKit(cart)) return;
      /* Free-gift honour (Matt, 2026-08-08): the kit landing can push
         the cart over the gift threshold, and _orchestrateFreeGift
         (which runs inside the same render that fired this event)
         will already have an async gift add in flight. Don't proceed
         until that add lands — the order must contain the gift and
         the BASKET-* mint must cover its retail. The gift add's own
         refresh() fires this event again with the gift line present;
         _giftInflight is still true at that moment, so the presence
         check (not the flag) is the settle signal. */
      if (self._giftInflight && !(cart.items || []).some(isGiftLineItem)) return;
      settle(true);
    }
    document.addEventListener('hgn:cart:change', onCartChange);
    try {
      document.dispatchEvent(new CustomEvent('hgn:kit:finalise-request', { detail: { tier: tier } }));
    } catch (err) {
      settle(false);
      return;
    }
    setTimeout(function () { settle(false); }, 15000);
  };

  /* Modal — intercepts a checkout click when a kit is at minimum
     but hasn't been finalised. "Finish my kit" closes the modal,
     opens the side cart, and scrolls to the relevant kit section
     so the shopper can pick accessories + auto-finalise. "No,
     check out anyway" proceeds straight to checkout — kit picks
     stay in localStorage (re-prompt next time). Resolves with
     'finish' or 'proceed'; never blocks. */
  HGNSideCart.prototype._showFinishKitPrompt = function (info) {
    var self = this;
    return new Promise(function (resolve) {
      var existing = document.querySelector('[data-hgn-finish-kit-modal]');
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

      var savingHtml = '';
      var savingText = '';
      /* LOCAL-sticker markets (M4): quote the fixed local-currency
         saving (formatMoney handles ISO codes) so the prompt agrees
         with the kit pricing block. When the overlay exists but its
         savings are 0, show NO saving rather than a GBP-derived one
         that's wrong for this market. GBP path is unchanged. */
      if (info.savingsLocal) {
        if (info.savingsLocal.savings > 0) {
          var formattedLocal = formatMoney(
            Math.round(info.savingsLocal.savings * 100), info.savingsLocal.currency);
          savingText = ' and save ' + formattedLocal;
          savingHtml = '<strong>' + escapeHtml(formattedLocal) + '</strong>';
        }
      } else if (info.savingsGbp > 0) {
        var formatted = (window.HGN && typeof window.HGN.formatLive === 'function' &&
                         typeof window.HGN.activeCurrencyKey === 'function')
          ? window.HGN.formatLive(info.savingsGbp, window.HGN.activeCurrencyKey())
          : '\u00a3' + info.savingsGbp.toFixed(2);
        savingText = ' and save ' + formatted;
        savingHtml = '<strong>' + escapeHtml(formatted) + '</strong>';
      }

      var modal = document.createElement('div');
      modal.className = 'hgn-finish-kit-modal';
      modal.setAttribute('data-hgn-finish-kit-modal', '');
      modal.innerHTML =
        '<div class="hgn-finish-kit-modal__scrim" data-hgn-finish-kit-cancel></div>' +
        '<div class="hgn-finish-kit-modal__panel" role="dialog" aria-modal="true" aria-labelledby="hgn-finish-kit-title">' +
          '<header class="hgn-finish-kit-modal__head">' +
            '<p class="hgn-finish-kit-modal__eyebrow">' + (info.allSet ? 'Your kit is ready' : 'Almost there') + '</p>' +
            '<h2 class="hgn-finish-kit-modal__title" id="hgn-finish-kit-title">' +
              (info.allSet
                ? 'Add your ' + escapeHtml(info.label) + (savingHtml ? ' and save ' + savingHtml : '') + '?'
                : 'Finish your ' + escapeHtml(info.label) + (savingHtml ? ' and save ' + savingHtml : '') + '?') +
            '</h2>' +
            '<p class="hgn-finish-kit-modal__copy">' +
              (info.allSet
                ? 'Your kit is all set &mdash; we’ll pop it in your basket' + escapeHtml(savingText) + ', then take you straight to checkout. Or check out without it.'
                : 'Your ' + info.minimum + ' picks are ready &mdash; choose your accessories to lock in the kit price' + escapeHtml(savingText) + '. Or check out without the kit.') +
            '</p>' +
          '</header>' +
          '<div class="hgn-finish-kit-modal__foot">' +
            '<button type="button" class="hgn-finish-kit-modal__cancel" data-hgn-finish-kit-proceed>No, check out anyway</button>' +
            '<button type="button" class="hgn-finish-kit-modal__confirm" data-hgn-finish-kit-finish>' +
              (info.allSet ? 'Add my kit &amp; check out' : 'Finish my kit') +
            '</button>' +
          '</div>' +
        '</div>';

      document.body.appendChild(modal);

      function done(decision) {
        if (modal.parentNode) modal.parentNode.removeChild(modal);
        document.removeEventListener('keydown', onKey);
        resolve(decision);
      }
      function onKey(e) { if (e.key === 'Escape') done('proceed'); }

      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-hgn-finish-kit-cancel]')) {
          /* Scrim click = "I want to think about this" — bounce back
             into the side cart, same as Finish my kit but without
             the explicit jump. Treating scrim as "proceed" would
             mis-fire if the shopper miss-tapped beside the panel. */
          done('finish');
          return;
        }
        if (e.target.closest('[data-hgn-finish-kit-finish]')) { done('finish'); return; }
        if (e.target.closest('[data-hgn-finish-kit-proceed]')) { done('proceed'); return; }
      });
      document.addEventListener('keydown', onKey);
    });
  };
})();
